import { inject } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { Router, ResolveFn } from '@angular/router';
import { VariableScaleManagerService } from '@shared/services/variable-scale-manager.service';
import { catchError, filter, of, take, timeout } from 'rxjs';

export const variableScaleLoaderResolver: ResolveFn<boolean> = () => {
  const router = inject(Router);
  const variableScaleManager = inject(VariableScaleManagerService);

  return toObservable(variableScaleManager.areRangesLoaded).pipe(
    filter((value) => value === true), // Wait for true
    take(1), // Take first true value
    timeout(15000), // Timeout after 15 seconds
    catchError(() => {
      router.navigate(['/404']);
      return of(false);
    }),
  );
};
